/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { CreateSessionEventMetricDto } from './create-session-event-metric-dto';
 /**
 *
 *
 * @export
 * @interface CreateSessionEventMetricsDto
 */
export interface CreateSessionEventMetricsDto {

    /**
     * @type {Array<CreateSessionEventMetricDto>}
     * @memberof CreateSessionEventMetricsDto
     */
    items: Array<CreateSessionEventMetricDto>;

    /**
     * Free-form session state snapshot (e.g. exerciseSequence, lap, phase). Persisted to Redis on each metrics call for crash recovery. Max 4096 bytes when JSON-serialized.
     *
     * @type {{ [key: string]: any; }}
     * @memberof CreateSessionEventMetricsDto
     */
    metadata?: { [key: string]: any; };
}
